(() => {
  const root = document.getElementById('bioline-collection-treatment');
  const intro = document.getElementById('bioline-line-intro');
  if (!root || !intro) return;
  const templates = new Map(Array.from(document.querySelectorAll('template[data-bioline-treatment]'), node => [node.dataset.biolineTreatment.toUpperCase(), node]));
  let current;
  const update = () => {
    const selected = (intro.dataset.currentLine || '').toUpperCase();
    const next = templates.has(selected) ? selected : '';
    if (next === current) return;
    current = next;
    root.replaceChildren(templates.get(next).content.cloneNode(true));
    root.dataset.currentLine = next;
  };
  new MutationObserver(update).observe(intro, {attributes:true,attributeFilter:['data-current-line']});
  window.addEventListener('pageshow', update);
  update();
})();
